import { declareParams } from '@farfetched/core';
import { zodContract } from '@farfetched/zod';
import { createAuthMutation } from '../auth-http-client';
import { jackpotSchema } from '../types';

export const createUnblockJackpotMutation = () =>
	createAuthMutation({
		params: declareParams<number>(),
		request: {
			method: 'POST',
			url: (id) => `/jackpot/unlock/${id}`,
			body: {},
		},
		response: {
			contract: zodContract(jackpotSchema),
		},
	});
